import { useEntities } from 'app/agriculture/queries/entities/useEntities';
import { getAssetIconConfig } from 'app/agriculture/icons/utils/map-icon-utils/getAssetIconConfig';
import { CesiumPolylineComponent } from 'app/agriculture/FarmMain/MapRenderer/components/CesiumPolylineComponent';
import { PolyLineEntityTypes } from 'app/agriculture/models/Entities';
import { InfraType } from 'app/agriculture/mutations/types/entityConfig';
import { useSelection } from 'app/agriculture/ContextMenu/hooks/useSelection/useSelection';

export function PolylineRenderer({
    entityType,
}: {
    entityType: (typeof PolyLineEntityTypes)[number] & InfraType;
}) {
    const entities = useEntities(entityType);
    const { borderColor = '#FFFFFF' } = getAssetIconConfig(entityType).options ?? {};
    const { isSelected } = useSelection();

    return (
        <>
            {Array.from(entities).map(([id, { geometry }]) => {
                return (
                    <CesiumPolylineComponent
                        key={id}
                        positions={Cesium.Cartesian3.fromDegreesArray(geometry.coordinates.flat())}
                        color={Cesium.Color.fromCssColorString(borderColor).withAlpha(
                            isSelected(id) ? 1 : 0.4,
                        )}
                        id={id}
                        width={5}
                    />
                );
            })}
        </>
    );
}
